import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import {
  VolumeInput,
  checkNumeric,
  formatNumber,
  randomFrom,
  randInt,
  renderFractionUserAnswer,
} from "./PyramidVolumeCommon";

export function generateTask() {
  const a = randomFrom([3, 4, 5, 6, 8, 9, 10, 12]);
  const h = 3 * randInt(2, 8);
  const baseArea = a * a;
  const volume = (baseArea * h) / 3;
  return {
    type: "RegularSquarePyramidVolumeTask",
    data: { a, h, baseArea, volume },
  };
}

export function renderTask({ data }) {
  return (
    <div style={{ textAlign: "left", lineHeight: 1.6 }}>
      <p>Dany jest ostrosłup prawidłowy czworokątny.</p>
      <BlockMath
        math={`a=${data.a}\\,\\text{cm},\\quad H=${data.h}\\,\\text{cm}`}
      />
      <p>Oblicz objętość tego ostrosłupa.</p>
    </div>
  );
}

export function renderInput(_task, userAnswer = {}, onChange, disabled) {
  return (
    <VolumeInput value={userAnswer} onChange={onChange} disabled={disabled} />
  );
}

export function checkAnswer({ data }, userAnswer) {
  return checkNumeric(userAnswer, data.volume);
}

export function renderAnswer({ data }) {
  return <InlineMath math={`V=${formatNumber(data.volume)}\\,\\text{cm}^3`} />;
}

export function renderUserAnswer(userAnswer) {
  return renderFractionUserAnswer(userAnswer, "V", String.raw`\text{cm}^3`);
}

export function renderExplanation({ data }) {
  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <p>
        <strong>Krok 1:</strong> W ostrosłupie prawidłowym czworokątnym podstawa jest kwadratem.
      </p>
      <BlockMath math={`P_p=a^2=${data.a}^2=${data.baseArea}\\,\\text{cm}^2`} />
      <p>
        <strong>Krok 2:</strong> Liczymy objętość ostrosłupa.
      </p>
      <BlockMath
        math={`V=\\frac{1}{3}P_p\\cdot H=\\frac{1}{3}\\cdot ${data.baseArea}\\cdot ${data.h}=${formatNumber(
          data.volume
        )}\\,\\text{cm}^3`}
      />
    </div>
  );
}
